<template>
  <div class="register">
    <div class="register-head">
     <div class="minw flex-between">
       <div class="title">企业工作台</div>
       <div class="back-login"><router-link to="login">返回登录</router-link></div>
     </div>
   </div>
   <div class="minw register-main">
    <div class="register-panel">
        <div class="register-desc-panel">
          <div class="tit">入驻农业产业服务云可以赋能</div>
          <img src="../../assets/images/user/register_bg.svg" alt="">
        </div>
        <div class="register-form-panel">
        <el-form :model="registerForm" :rules="registerRules" ref="registerFormRef">
            <el-form-item prop="loginName" key="loginName">
                <el-input placeholder="请输入用户名" v-model="registerForm.loginName" :prefix-icon="User" @change="loginNameVerify"></el-input>
            </el-form-item>
            <el-form-item  prop="registTel">
                <el-input placeholder="请输入手机号码" v-model="registerForm.registTel" :prefix-icon="Iphone"></el-input>
            </el-form-item>
            <el-form-item  prop="mobileCode">
                <div class="mobile-code">
                    <el-input placeholder="请输入短信验证码" v-model="registerForm.mobileCode" :prefix-icon="MessageBox"></el-input>
                    <el-button @click="mobileVerify(registerForm.registTel)" :disabled="countdownDisable">{{countdown}}</el-button>
                </div>
            </el-form-item>
            <el-form-item prop="password">
                <el-input type="password" placeholder="设置6至20位登录密码" v-model="registerForm.password" :prefix-icon="Lock"></el-input>
            </el-form-item>
            <el-form-item prop="confirmPassword">
                <el-input type="password" placeholder="请再次输入登录密码" v-model="registerForm.confirmPassword" :prefix-icon="Lock"></el-input>
            </el-form-item>
            <div class="register-agree">
              <el-checkbox v-model="checkboxFlag">勾选代表您同意</el-checkbox>
              <span class="cor-active" @click="jumper">《商家用户协议》</span>
            </div>
            <div><el-button type="primary" class="submit-btn" @click="onSubmit(registerFormRef)">注 册</el-button></div>
            <div class="login-router"><router-link to="login">已有账号，<span>立即登录</span></router-link></div>
        </el-form>
        </div>
    </div>
    <!-- <div class="settle-steps">
        <el-steps :active="0">
            <el-step title="账号注册" description="注册账号拥有通行证"></el-step>
            <el-step title="资质填写" description="个人/企业信息填写"></el-step>
            <el-step title="平台审核" description="平台对商家信息审核"></el-step>
            <el-step title="易宝开户" description="第三方支付平台开户审核"></el-step>
            <el-step title="入驻成功" description="法人认证，使用平台" ></el-step>
        </el-steps>
    </div>
    <div class="settle-tel">入驻管家服务电话：15010677627</div> -->
   </div>
  </div>
</template>

<script>
import { getCurrentInstance, reactive, ref, toRefs } from "vue";

import { User,Iphone,MessageBox,Lock } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router';
import Md5 from 'js-md5';
export default {
  name:"reGister",
  setup(){
    const { proxy }=getCurrentInstance();
    const router=useRouter();
    let pageData=reactive({
      timer:null,
      count:0,
      countdownDisable:false,
      countdown:"获取验证码",
      checkboxFlag:false
    });
    let registerFormRef=ref();
    let registerForm=reactive({
      "confirmPassword": "",
      "loginName": "",
      "mobileCode": "",
      "password": "",
      "registTel": ""
    });
    let registerRules=reactive({
      loginName: [
        { required: true, message: "请输入用户名", trigger: "blur" },
        {
          pattern: /^[0-9A-Za-z_]{4,16}$/,
          message: "请输入4-16位数字/字母/下划线组成的用户名",
          trigger: "blur",
        },
        {
          validator: (rule, value, callback) => {
            if (registerForm.loginNameFlag) {
              callback(new Error('用户名已存在'))
            } else {
              callback()
            }
          }
        }
      ],
      registTel: [
        { required: true, message: "请输入手机号", trigger: "blur" },
        {
          pattern: /^[1][0-9]{10}$/,
          message: "请输入正确的手机号码",
          trigger: "blur",
        },
        {
          validator: (rule, value, callback) => {
            if (registerForm.registTelFlag) {
              callback(new Error('手机号已存在'))
            } else {
              callback()
            }
          }
        }
      ],
      mobileCode: [
        { required: true, message: "请输入验证码", trigger: "blur" },
      ],
      password: [
        { required: true, message: "请输入密码", trigger: "blur" },
        {
          pattern: /^[0-9A-Za-z_]{6,16}$/,
          message: "请输入6-16位数字/字母/下划线组成的密码",
          trigger: "blur",
        },
      ],
      confirmPassword: [{required: true,message: '请再次输入登录密码',trigger: "blur"},
        {
          validator: (rule, value, callback) => {
            // 注意这里如果用的是methods里的isMobilePhone将不生效
            if (registerForm.confirmPassword == registerForm.password) {
              callback()
            } else {
              callback(new Error('请输入相同的密码'))
            }
          }
        }
      ],
    });
    function onSubmit(formEl){
      formEl.validate((valid) => {
        if (valid) {
          console.log('submit!')
        } else {
          return false
        }
        if(!pageData.checkboxFlag){
          proxy.$message("请勾选商家入驻协议");
          return
        }
        var password = Md5(registerForm.password);
        var passwordC = Md5(registerForm.confirmPassword);
        proxy.$request({
          url:"SYSTEM_MEMB_REGISTER",
          method: "post",
          data:{
            "confirmPassword":passwordC,
            "loginName": registerForm.loginName,
            "mobileCode": registerForm.mobileCode,
            "password": password,
            "registTel":registerForm.registTel
          },
        }).then((res) => {
          if(res.data.code=='000'){
            router.push('login')
          }
        }).catch((err) => {
          console.log(err)
        });
      })
    }
    function getCountDown() {
      const TIME_COUNT = 60;
      if (!pageData.timer) {
        pageData.count = TIME_COUNT;
        pageData.timer = setInterval(() => {
          if (pageData.count > 0 && pageData.count <= TIME_COUNT) {
            pageData.countdownDisable = true;
            let str = pageData.count--;
            pageData.countdown = str + "s重新获取验证码";
          } else {
            clearInterval(pageData.timer);
            pageData.timer = null;
            pageData.countdown = "获取验证码";
            pageData.countdownDisable = false;
          }
        }, 1000);
      }
    }
    function getCode(mobile) {//获取验证码
      registerFormRef.value.validateField("registTel",(valid) => {
        if(!valid)return false
        proxy.$request({
          url:"SYSTEM_MOBILE_VALCODE_CREATE",
          method: "post",
          data: {
            mobile: mobile,
          },
        }).then((res) => {
          if(res.data.code=='000'){
            getCountDown();
          }
        }).catch((err) => {
          console.log(err)
        });
      });
    }
    function mobileVerify() {//手机号码验证
      registerForm.registTelFlag=false;
      registerFormRef.value.validateField("registTel",(valid) => {
        if(!valid)return false
        proxy.$request({
          url:"SYSTEM_MEMB_CHECKMOBILEEXIST",
          method: "post",
          data: {
            "key": registerForm.registTel,
            "mainFlag": true
          },
        }).then((res) => {
          if(res.data.code=='000'){
            registerForm.registTelFlag=false;
            getCode(registerForm.registTel);
          }else{
            registerForm.registTelFlag=true;
          }
          registerFormRef.value.validateField("registTel")
        })
      });
    }
    function loginNameVerify(){//验证用户名
      registerForm.loginNameFlag=false;
      registerFormRef.value.validateField("loginName",(valid) => {
        if(!valid)return false
        proxy.$request({
          url:"SYSTEM_MEMB_CHECKLOGINNAMEEXIST",
          method: "post",
          data: {
            "key": registerForm.loginName,
            "mainFlag": true
          },
        }).then((res) => {
          if(res.data.code=='000'){
            registerForm.loginNameFlag=false;
          }else{
            registerForm.loginNameFlag=true;
          }
          registerFormRef.value.validateField("loginName")
        }).catch((err) => {
          console.log(err)
        });
      });
    }
    function jumper(){
      let url=router.resolve({
        path: "userAgreement",
      })
      proxy.tool.openWindow(url.href,'_blank');
    }
    return {
      registerFormRef,
      registerForm,
      registerRules,
      User,
      Iphone,
      MessageBox,
      Lock,
      onSubmit,
      mobileVerify,
      pageData,
      ...toRefs(pageData),
      loginNameVerify,
      getCode,
      jumper
    }
  }
};
</script>

<style lang="less" scoped>
.register{
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-size: 0.875rem;
  color: #222222;
  background: #f5f5f5;
  .flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
  };
  .cor-active{
    color: #3d7efd;
    cursor: pointer;
  }
  .minw{
    width: 81rem;
    margin:0 auto;
  }
  .register-head{
      width: 100%;
      background: #fff;
      height: 4rem;
      line-height: 4rem;
      .title{
        font-size: 1.125rem
      }
      .back-login{
        a{
          color: #222222;
          text-decoration: none;
        }
      }
  }
  .register-main{
    .settle-steps{
      width: 100%;
      margin-bottom: 2rem;
    }
    .settle-tel{
      text-align: center;
      color: #707070;
      font-family: PingFangSC-Regular;
    }
    height: calc(100vh - 4rem);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .register-panel{
      width: 100%;
      height: 35rem;
      margin-bottom: 2rem;
      position: relative;
      background: #fff;
      color: #222222;
      .register-desc-panel{
        width: 46rem;
        padding-top:2.875rem;
        padding-left: 3.75rem;
        .tit{
          margin-bottom: 2.5rem;
          font-size: 1.625rem;
          font-weight: bold;
          text-align: center;
        }
        img{
          width: 46rem;
          height:25.5rem;
        }
      }
    .register-form-panel{
      width: 24.375rem;
      position: absolute;
      right:5rem;
      top: 3.8125rem;
      :deep(.el-form-item){
         margin-bottom: 1.875rem;
        .el-input__wrapper{
          padding: 0;
          padding-bottom: 0.875rem;
          box-shadow: none;
          border-radius: 0;
          border-bottom: 1px solid #dfe1e4;
        }
        .el-input__inner{
          height: 1.25rem;
          line-height: 1.25rem;
          font-size: 0.875rem;
        }
        .el-form-item__error{
          z-index: 2;
          font-size: 0.75rem;
        }
      }
      .mobile-code{
        width: 100%;
        display: flex;
        align-items:flex-end;
        .el-button{
          height: 2.25rem;
          padding: 0.5rem 0.75rem;
          border-radius: 0.25rem;
          margin-left: 0.6rem;
          font-size: 0.875rem;
          color: #222222;
          border-color: #dfe1e4;
        }
        .el-button.is-disabled{
          color: #999;
        }
      }
      .register-agree{
        display: flex;
        align-items: center;
        margin-top: -0.875rem;
        margin-bottom: 1.625rem;
        font-size:0.75rem;
        color: #222222;
        :deep(.el-checkbox__label){
          font-size: 0.875rem;
        }
        :deep(.el-checkbox){
          height: 2rem;
          line-height: 2rem;
          font-size: 0.875rem;
          --el-checkbox-input-height:12px;
          --el-checkbox-input-width:12px;

          .el-checkbox__inner::after{
            width: 2px;
            height: 5px;
          }
        }
      }
      .submit-btn{
        width: 100%;
        height: 2.875rem;
        border-radius: 0.125rem;
        margin-bottom: 0.75rem;
        font-size: 0.875rem;
        background: #3d7efd;
      }
      .login-router{
        text-align: center;
        a{
          font-size: 0.75rem;
          color: #3d7efd;
        }
      }
    }
  }

  }
  @media only screen and (max-width: 1440px) {
    .register-head{
      height: 5.83rem;
      line-height: 5.83rem;
      font-size: 1.17rem;
      .title{
        font-size: 1.3rem;
      }
    }
    .register-main{
      .register-panel{
        .register-form-panel{
          :deep(.el-form-item){
            .el-input__inner{
              font-size: 1.16rem;
            }
          }
          .mobile-code{
            .el-button{
              font-size: 1.16rem;
            }
          }
          .register-agree{
            :deep(.el-checkbox__label){
              font-size: 1rem;
            }
            :deep(.el-checkbox){
              font-size: 1rem;
              .el-checkbox__inner::after{
                width: 2px;
                height: 5px;
              }
            }
          }
          .submit-btn{
            font-size: 1.16rem;
          }
          .login-router{
            a{
              font-size: 1rem;
            }
          }
        }
      }
    }
  }
}

</style>

<style>
@media only screen and (max-width: 1920px) {
  html {
    font-size: 16px;
  }
}
@media only screen and (max-width: 1440px) {
  html {
    font-size: 12px;
  }
}
</style>